import {Component, OnInit, ViewChild, Inject} from '@angular/core';
import {TylerMatTableDataSource} from '../../../shared-components/angular-material/extended.class';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {Subscription} from 'rxjs';
import {StudentDocumentAccessHistory} from '../../../shared-components/student/student-documents-accesshistory.model';

@Component({
    selector: 'app-student-document-access-history',
    templateUrl: './student-document-access-history.component.html',
    styleUrls: ['./student-document-access-history.component.css']
})
export class StudentDocumentAccessHistoryComponent implements OnInit {
    dataSource = new TylerMatTableDataSource();
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    public columnsToDisplay: string[] = ['FirstName', 'LastName', 'MiddleName', 'TimeStamp'];

    subscriptions: Subscription[] = [];
    studentDocumentAccessHistory: StudentDocumentAccessHistory[];
    v10: boolean;
    private _paginator: MatPaginator;
    @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
        this._paginator = value;
        this.dataSource.paginator = value;
    }

    constructor(private dialogRef: MatDialogRef<StudentDocumentAccessHistory>,
                private dialog: MatDialog,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.studentDocumentAccessHistory = data.AccessHistory;
        this.dataSource = new TylerMatTableDataSource(this.studentDocumentAccessHistory);
    }

    ngOnInit() {
        this.getStudentDocumentAccessHistory();
    }

    getStudentDocumentAccessHistory() {
        this.dataSource.data = this.studentDocumentAccessHistory;
        this.dataSource.sort = this.sort;
    }

    cancelClick() {
        this.dialogRef.close();
    }
}
